import { connect } from "react-redux";
import React from "react";
import { login, logout } from "store/modules/common/loginReducer";

const WrappedComponent = (props) => {
    const { component, ...otherProps } = props;
    const WrappedComponent = component;
    return <WrappedComponent {...otherProps} />;
};

const mapStateToProps = (state, ownProps) => ({
    signedIn: state.signedIn,
    userId: state.userId,
});

const mapDispatchToProps = (dispatch) => ({
    login: (authInfo) => dispatch(login(authInfo)),
    logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
